jQuery(document).ready(function($) {  
  
  /*
  jQuery throttle / debounce - v1.1 - 3/7/2010 -- Rewritten to accommodate webpack compilation
  http://benalman.com/projects/jquery-throttle-debounce-plugin/
  */
  function st_throttle(e,f,j,i){var c=undefined;var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g}

  // Global function that works with dynamically generated content on the page
  function applyWhenElementExists(selector, myFunction, intervalTime) {
    var interval = setInterval(function() {
      if (jQuery(selector).length > 0) {
        myFunction();
        clearInterval(interval);
      }
    }, intervalTime);
  }

  /*
  $(window).on('scroll', st_throttle(500, function() {
    console.log('do something');
  }));
  */

  /* FEATURED LOGOS - GRID SLIDER ------------------------------- */
  $('.featured-logos.grid').each(function() {

    // Set variables
    var $container = $(this);
    var $slider = $('.logos-container > .wrap', $container);
    var slide_count = $('.grid-slider-item', $slider).length;
    var $slider_nav = $('.slider-nav', $container);
    var $nav_prev = $('.slider--prev', $slider_nav);
    var $nav_next = $('.slider--next', $slider_nav);
    
    // Set nav buttons
    $nav_prev.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });
    
    $nav_next.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });

    $slider.on('init reInit breakpoint', function(slick) {

      // Determine if custom navigation should show/hide
      var active_slides = $('.slick-active', $slider).length;
      if (active_slides < slide_count) {
        $slider_nav.addClass('show');
      } else {
        $slider_nav.removeClass('show');
      }

    });

    // Set slider variables
    var slider_args = {

      dots: false,
      arrows: false,
      infinite: true,
      regionLabel: 'Featured-In Logos Slider',
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1301,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    // Initialize slider
    $slider.slick(slider_args);

  });


  /* FEATURED LOGOS - PURE SLIDER ------------------------------- */
  $('.featured-logos.slider').each(function() {

    // Set variables
    var $container = $(this);
    var aria_label = $container.data('aria-label');
    var $slider = $('.logos-container > .wrap', $container);

    // Function to resize the slide heights
    function resize_slide_heights() {

      // Reset min-heights
      $('.slider-item .item', $slider).css({
        'min-height': ''
      });

      // Set min-height variable
      var min_height = 0;

      // Iterate over each item and set the min-height value
      $('.slider-item .item', $slider).each(function() {

        if ($(this).innerHeight() > min_height) {
          min_height = $(this).innerHeight();
        }

      });

      // Set min-heights
      $('.slider-item .item', $slider).css({
        'min-height': min_height+'px'
      });

    }

    $slider.on('init reInit breakpoint', function(slick) {

      // Resize slide heights on page load
      resize_slide_heights(); 

    });
    
    // Resize slide heights on window resize
    $(window).on('resize', st_throttle(1000, function() {
      resize_slide_heights(); 
    }));

    // Set slider variables
    var slider_args = {

      dots: false,
      arrows: false,
      centerMode: true,
      centerPadding: '100px',
      infinite: true,
      regionLabel: aria_label,
      slidesToShow: 7,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1601,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    // Initialize slider
    $slider.slick(slider_args);

  });


  /* POSTS GRID ------------------------------------------------- */
  $('.posts-block').each(function() {

    // Declare variables
    $container = $(this);
    $filter = $('.post-list-filtering', $container);
    $category_filter = $('select[name="filter-category"]', $filter);
    $sort_filter = $('select[name="filter-sort"]', $filter);
    $text_search = $('input[name="filter-text"]', $filter);

    $text_search.on('focus', function() {
      if ($(this).val() == 'Search') {
        $(this).val('');
      }
    });

    $text_search.on('blur', function() {
      if ($(this).val() == '') {
        $(this).val('Search');
      }
    });

    $filter.on('submit', function() {
      if ($text_search.val() == 'Search') {
        $text_search.val('');
      }
    });

    $category_filter.on('change', function() {
      $filter.submit();
    });

    $sort_filter.on('change', function() {
      $filter.submit();
    });

    // Function to set the heights of the content areas
    function set_content_height() {

      // Reset min-heights
      $('article.item .content', $container).css({
        'min-height': ''
      });

      if ($(window).width() > 600) {

        // Set min-height variable
        var min_height = 0;

        // Iterate over each item and set the min-height value
        $('article.item .content', $container).each(function() {

          if ($(this).innerHeight() > min_height) {
            min_height = $(this).innerHeight();
          }

        });

        // Set min-heights
        $('article.item .content', $container).css({
          'min-height': min_height+'px'
        });

      }

    }

    // Set content heights on page load
    set_content_height();
    
    // Resize content heights on window resize
    $(window).on('resize', st_throttle(1000, function() {
      set_content_height(); 
    }));

  });


  /* TESTIMONIALS SLIDER ---------------------------------------- */
  $('.wp-block-singular.testimonials-slider').each(function() {

    // Set variables
    var $container = $(this);
    var $slider = $('.slider > .wrap', $container);
    var slide_count = $('.testimonial', $slider).length;
    var $slider_nav = $('.slider-nav', $container);
    var $nav_prev = $('.slider--prev', $slider_nav);
    var $nav_next = $('.slider--next', $slider_nav);
    
    // Set nav buttons
    $nav_prev.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });
    
    $nav_next.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });

    // Function to resize the slide heights
    function resize_slide_heights() {

      // Reset min-heights
      $('.testimonial > .wrap', $slider).css({
        'min-height': ''
      });

      // Set min-height variable
      var min_height = 0;

      // Iterate over each item and set the min-height value
      $('.testimonial > .wrap', $slider).each(function() {

        if ($(this).innerHeight() > min_height) {
          min_height = $(this).innerHeight();
        }

      });

      // Set min-heights
      $('.testimonial > .wrap', $slider).css({
        'min-height': min_height+'px'
      });

    }

    $slider.on('init reInit breakpoint', function(slick) {

      // Resize slide heights on page load
      resize_slide_heights(); 

      // Determine if custom navigation should show/hide
      var active_slides = $('.slick-active', $slider).length;
      if (active_slides < slide_count) {
        $slider_nav.addClass('show');
      } else {
        $slider_nav.removeClass('show');
      }

    });
    
    // Resize slide heights on window resize
    $(window).on('resize', st_throttle(1000, function() {
      resize_slide_heights(); 
    }));


    // Set slider arguments
    var slider_args = {
      arrows: false,
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1101,
          settings: {
            slidesToShow: 1,
            fade: false
          }
        },
        {
          breakpoint: 801,
          settings: {
            slidesToShow: 1,
            fade: true
          }
        }
      ]
    };

    // Initialize slider
    $slider.slick(slider_args);

  });

});